import React from 'react';
import styled from '@emotion/styled';
import _ from 'lodash';
import { ClassicSpinner } from 'react-spinners-kit';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

const LoadingScreen = () => {
  return (
    <Wrapper>
      <ClassicSpinner color="#fff" size={60} />
    </Wrapper>
  );
};

export default LoadingScreen;
